export const isLocationSelected = (
  locationUuid: string,
  creatorMultipostConfig: any
) => {
  // check if config keys has the location uuid
  const locations = Object.keys(creatorMultipostConfig).map((key) => {
    return key.split("_")[0];
  });
  return locations.includes(locationUuid);
};

export const isPlatformActive = (
  creatorMultipostConfig: any,
  locationUuid: string,
  platform: string
) => {
  const key = `${locationUuid}_${platform}`;
  return creatorMultipostConfig[key];
};
